import { useEffect, useState } from "react";
import BodyTeamCard from "./bodyTeamCard/bodyTeamCard";
import FooterTeamCard from "./footerTeamCard/footerTeamCard";
import HeaderTeamCard from "./headerTeamCard/headerTeamCard";
import WidgetContainer from "../reusablesComponents/containerWidget";
import { getTeamCard } from "../../services/getTeamCard";
import "./teamCard.sass";

export default function TeamCard({ type, sport, idEvent }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // --- Fetch de datos ---
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await getTeamCard({ type, sport, idEvent });
        setData(result.statusCode === 200 ? result.data : null);
      } catch (error) {
        console.error("Error fetching team card:", error);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [type, sport, idEvent]);

  return (
    <WidgetContainer loading={loading} heightLoading={""} className="container__team-card" id="container__team-card">
      <div className="team-card__component">
        <HeaderTeamCard liga={"liga mx"} />
        <BodyTeamCard data={data} />
        <FooterTeamCard data={data?.botones} />
      </div>
    </WidgetContainer>
  )
}